"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.reports.cost': '成本报告',
    'route.reports.shared': '共享对话',
};
